import { gsap } from 'gsap';
import { indexOf as _indexOf } from 'underscore';
import Cookies from 'js-cookie';

export default class gdprBar{

    constructor(options) {

        this.defaults = {
        	main 			: undefined,
        	$el   			: $( '#gdpr-bar' ),

        	// https://geolocation-db.com
        	// api key to registered user filippo@forofficeuseonly.com
        	geolocation_url	: 'https://geolocation-db.com/jsonp/7733a990-ebd4-11ea-b9a6-2955706ddbf3', //6db070f0-7c27-11ea-8264-e974339fc182',
	    	eu_country_codes : [
				'AT', // - Austria
				'BE', // - Belgium
				'BG', // - Bulgaria
				'CY', // - Cyprus
				'CZ', // - Czech Republic
				'DE', // - Germany
				'DK', // - Denmark
				'EE', // - Estonia
				'ES', // - Spain
				'FI', // - Finland
				'FR', // - France
				'GR', // - Greece 
				'HR', // - Croatia
				'HU', // - Hungary
				'IE', // - Ireland
				'IT', // - Italy
				'LT', // - Lithuania
				'LU', // - Luxembourg
				'LV', // - Latvia
				'MT', // - Malta
				'NL', // - Netherlands
				'PO', // - Poland
				'PT', // - Portugal
				'RO', // - Romania
				'SE', // - Sweden
				'SI', // - Slovenia
				'SK'  // - Slovakia
			],

			retry: 4 // times to retry if some error occurs
        }
        this.options = {};
		Object.assign(this.options, this.defaults, options);

		this.namespace 		= 'mspc-gdpr-bar';
		this.main			= this.options.main;
		this.$el 			= this.options.$el;
		this.index_retry	= 0;
		//this.init()
    }

    init( delay ){
    	if ( this.$el.length > 0 ){
    		setTimeout(()=>this.initGeoIp(), delay );
    	}
    }

    activateGDPR(){
		const cookie = 'mspc-gdpr-bar'; // + window.location.host;
		//console.log(  'activateGDPR, Cookies = ' + Cookies );
		if ( !Cookies ) {
			return;
		}
		//console.log( Cookies.get( cookie ) );
		// Check cookie 
		if ( Cookies.get( cookie ) !== "active" ) {
			// show bar
			this.$el.addClass( 'active' );
			//Assign cookie on click
			this.$el.find('.close-icon, a').on('click', () => {
				Cookies.set( cookie , 'active', { expires: 90 }); // cookie will expire in 90 day
				// hide bar
				gsap.to( this.$el, { duration:0.4, opacity:0, bottom:0, ease: 'Linear.easeOut', onComplete:()=>this.remove()})
			});
		}
		else{
			this.remove();
		}
		
    }

    initGeoIp(){
    	// https://geolocation-db.com 
		$.ajax( {
			type: 			'get',
		 	url: 			this.options.geolocation_url,
		 	dataType: 		'jsonp',
		 	jsonpCallback: 	'callback'
		}).then(
	      	(response) => this.response(response),
	      	(data, status) => this.error(data,status)
		);	    	
    }

    response( response ){
      	// console.log('GDPR: User\'s Location Data is ', response );
      	if ( _indexOf( this.options.eu_country_codes, response.country_code ) !== -1 ){
      		this.activateGDPR();
      	}
      	else{
      		this.remove();
      	}
    }

    error(){ //data, status ){
      	// console.log('GDPR: Request failed.  Returned status of: ', status );
      	this.index_retry++;
      	if ( this.index_retry <= this.options.retry ){
      		this.init( 377 );
      		return;
      	}
      	this.activateGDPR();
    }

    remove(){
    	this.$el.remove();
    }

}



